import { PageContainer } from '@/components/organisms';
import { SectionTitle } from '@/components/molecules';
import {Icon} from '@/components/atoms'
import {COLOR_CODE} from '@/utils/constants/colors'

const InfoItem = ({label, value, isHighlighted, icon}) => (
  <div className="col-span-1 pt-4">
    <div className="flex items-center gap-2">
      <span className="key text-sm" style={{color: COLOR_CODE._D0D0D0}}>
        {label}
      </span>
      {icon && <Icon alt={icon.alt} icon={icon.name} size={icon.size || 'small'} />}
    </div>
    <h2
      className="val text-base font-bold"
      style={isHighlighted ? {color: COLOR_CODE._3387DF} : {color: COLOR_CODE._FFFFFF}}
    >
      {value !== undefined && value !== null && value !== '' ? value : '-'}
    </h2>
  </div>
)
const Section = ({id, title}) => {
  return <SectionTitle id={id} label={title} />
}

const DisplayInformation = ({orderDetails}) => (
  <>
    {/* Order Identifiers Section */}
    <div className="order-overview">
      <div className="sc-border grid pl-4">
        <Section id="order_identifiers" title="Order Identifiers" />
      </div>
      <div className="grid grid-cols-3 gap-4 pb-6 pl-4">
        <InfoItem label="Payment Transaction ID" value={orderDetails?.paymentTransactionId} />
        <InfoItem label="SF Order ID" value={orderDetails?.sfOrderId} />
        <InfoItem label="Payment Transaction System" value={orderDetails?.paymentTransactionSystem} />
      </div>
    </div>

    {/* Payment Information Section */}
    <div className="order-overview">
      <div className="sc-border grid pl-4">
        <Section id="payment_information" title="Payment Information" />
      </div>
      <div className="grid grid-cols-3 gap-4 pb-6 pl-4">
        <InfoItem label="Payment Transaction Status" value={orderDetails?.paymentTransactionStatus} />
        <InfoItem label="Payment Transaction Amount" value={orderDetails?.paymentTransactionAmount} />
        <InfoItem label="Transaction Date" value={orderDetails?.transactionDate} />
        <InfoItem label="Payment Method Code" value={orderDetails?.paymentMethodCode} />
        <InfoItem label="Card Type" value={orderDetails?.cardType} />
        <InfoItem label="Last Four Digit (Card Number)" value={orderDetails?.lastFourDigit} />
      </div>
    </div>

    {/* Schedule & Payment Details Section */}
    <div className="order-overview">
      <div className="sc-border grid pl-4">
        <Section id="schedule_payment_details" title="Schedule & Payment Details" />
      </div>
      <div className="grid grid-cols-3 gap-4 pb-6 pl-4">
        <InfoItem label="Visit Schedule ID" value={orderDetails?.visitScheduleId} />
        <InfoItem label="Customer PO ID" value={orderDetails?.customerPoId} />
        <InfoItem label="Payment Terms Code" value={orderDetails?.paymentTermsCode} />
        <InfoItem label="Order Payment Status" value={orderDetails?.orderPaymentStatus} />
      </div>
    </div>
  </>
)

const OrderDigitalPaymentPage = ({ orderDetails }) => {
  return (
    <PageContainer>
      <DisplayInformation orderDetails={orderDetails} />
    </PageContainer>
  );
};

export default OrderDigitalPaymentPage;